/* eslint-disable @typescript-eslint/no-floating-promises */
import { RouterProvider } from "react-router-dom";
import "antd/dist/reset.css";

import { router } from "./routes";
import { useEffect } from "react";

import { initOneSignal } from "@services/onesignal/oneSignal";

export const App = () => {
  useEffect(() => {
    initOneSignal();
  }, []);

  return <RouterProvider router={router} />;
};
